// extracted by mini-css-extract-plugin
export default {"sectionHeader":"header_sectionHeader__O-isM"};